import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, } from '@angular/common/http';
import { SpinnerService } from './Services/spinner';
import { finalize, tap } from 'rxjs/operators';



@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {

  constructor(private spinner: SpinnerService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {

      this.spinner.start();

      return next.handle(req).pipe(
        tap(
          // Succeeds when there is a response; ignore other events
          event => {},
          error => {
            this.spinner.stop();
          }
        ),
        finalize(() => {
          // finally handle? but apparent we don't arrive here upon error
          this.spinner.stop();
        })
      );
    }
}



// WEBPACK FOOTER //
// ./src/app/spinnerinterceptor.ts